function cloneBranch(current: unknown, nextPart: string): unknown {
  const nextIsIndex = /^\d+$/.test(nextPart)
  if (Array.isArray(current)) {
    return [...current]
  }
  if (current && typeof current === 'object') {
    return { ...(current as Record<string, unknown>) }
  }
  return nextIsIndex ? [] : {}
}

export function applySlideFieldEdit(
  slide: Record<string, unknown>,
  field: string,
  value: string,
) {
  const next = { ...slide } as Record<string, unknown>
  const parts = field.split('.')
  let target: Record<string, unknown> | Array<unknown> = next
  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i]
    const nextPart = parts[i + 1]
    const current = (target as Record<string, unknown>)[key]
    const cloned = cloneBranch(current, nextPart)
    ;(target as Record<string, unknown>)[key] = cloned as never
    target = cloned as Record<string, unknown>
  }
  ;(target as Record<string, unknown>)[parts[parts.length - 1]] = value
  return next
}
